<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'dashboard-1' }">
        Dashboard
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        ข้อมูลร้านค้า
      </b-breadcrumb-item>
    </b-breadcrumb>

    <!-- <user-detail-add-new-work
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
    /> -->

    <b-row>
      <b-col>
        <b-card class="mb-1">
          <b-row>
            <!-- User Info: Left col -->
            <b-col
              cols="6"
              xl="6"
              class="d-flex justify-content-center flex-column"
            >
              <!-- User Avatar & Action Buttons -->
              <div class="d-flex justify-content-start">
                <b-avatar :src="shopModel.avatar" size="104px" rounded />
                <div class="d-flex flex-column ml-1">
                  <div class="mb-1">
                    <h4 class="mb-1">
                      {{ shopModel.shopName }}
                    </h4>
                  </div>
                  <div class="d-flex flex-wrap">
                    <b-button
                      :to="{
                        name: 'shop-edit',
                        params: { id: shopModel.contactId },
                      }"
                      variant="primary"
                    >
                      Edit
                    </b-button>
                    <!-- <b-button
                      variant="outline-danger"
                      class="ml-1"
                    >
                      Delete
                    </b-button> -->
                  </div>
                </div>
              </div>

              <!-- User Stats -->
              <div class="d-flex align-items-center mt-2">
                <div class="d-flex align-items-center mr-2">
                  <b-avatar variant="light-primary" rounded>
                    <feather-icon icon="DollarSignIcon" size="18" />
                  </b-avatar>
                  <div class="ml-1">
                    <h6 class="mb-0">
                      23.3k
                    </h6>
                    <small>ยอดขายทั้งหมด</small>
                  </div>
                </div>

                <div class="d-flex align-items-center mr-2">
                  <b-avatar variant="light-warning" rounded>
                    <feather-icon icon="BoxIcon" size="18" />
                  </b-avatar>
                  <div class="ml-1">
                    <h6 class="mb-0">
                      21 orders
                    </h6>
                    <small>สินค้าทั้งหมด</small>
                  </div>
                </div>

                <div class="d-flex align-items-center">
                  <b-avatar variant="light-success" rounded>
                    <feather-icon icon="ClipboardIcon" size="18" />
                  </b-avatar>
                  <div class="ml-1">
                    <h6 class="mb-0">
                      21 orders
                    </h6>
                    <small>รายการขายทั้งหมด</small>
                  </div>
                </div>
              </div>
            </b-col>

            <!-- Right Col: Table -->
            <b-col cols="6" xl="6">
              <!-- <table class="mt-xl-0 w-100">
                <tr>
                  <th class="pb-50">
                    <span class="font-weight-bold">Username</span>
                  </th>
                  <td class="pb-50">
                    {{ shopModel.userName }}
                  </td>
                </tr>

                <tr>
                  <th class="pb-50">
                    <span class="font-weight-bold">Password</span>
                  </th>
                  <td class="pb-50 text-capitalize">
                    {{ shopModel.password }}
                  </td>
                </tr>

                <tr>
                  <th class="pb-50">
                    <span class="font-weight-bold">ชื่อ :</span>
                  </th>
                  <td class="pb-50 text-capitalize">
                    {{ shopModel.firstName }}
                  </td>
                </tr>

                <tr>
                  <th class="pb-50">
                    <span class="font-weight-bold">นามสกุล :</span>
                  </th>
                  <td class="pb-50 text-capitalize">
                    {{ shopModel.lastName }}
                  </td>
                </tr>

                <tr>
                  <th class="pb-50">
                    <span class="font-weight-bold">เพศ :</span>
                  </th>
                  <td class="pb-50">
                    {{ shopModel.sex }}
                  </td>
                </tr>

                <tr>
                  <th class="pb-50">
                    <span class="font-weight-bold">วัน/ เดือน/ ปี/ เกิด :</span>
                  </th>
                  <td class="pb-50 text-capitalize">
                    {{ shopModel.birthDate }}
                  </td>
                </tr>
              </table> -->
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col>
        <b-card title="ข้อมูลการติดต่อ :">
          <table class="mt-xl-0 w-100">
            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">เบอร์โทรศัพท์ :</span>
              </th>
              <td class="pb-50">
                {{ shopModel.phone }}
              </td>
            </tr>

            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">อีเมล :</span>
              </th>
              <td class="pb-50 text-capitalize">
                {{ shopModel.email }}
              </td>
            </tr>

            <tr>
              <th class="pb-50">
                <span class="font-weight-bold">ที่อยู่ :</span>
              </th>
              <td class="pb-50 text-capitalize">
                {{ shopModel.address }}
              </td>
            </tr>
          </table>
        </b-card>
      </b-col>

      <b-col>
        <b-card title="ประวัติการเงินของฉัน :">
          <app-timeline>
            <app-timeline-item>
              <div
                class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
              >
                <h6>ยอดขายทั้งหมด</h6>
                <small class="text-muted">23.3 k</small>
              </div>
            </app-timeline-item>

            <app-timeline-item variant="warning">
              <div
                class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
              >
                <h6>การถอนเงินทั้งหมด</h6>
                <small class="text-muted">20 k</small>
              </div>
            </app-timeline-item>

            <app-timeline-item
              variant="info"
              title="การคืนเงินทั้งหมด"
              time="3 k"
            />
          </app-timeline>
        </b-card>
      </b-col>
    </b-row>

    <!-- <user-address-list :user-address-list="userData.addressInformation" /> -->
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
import {
  BRow,
  BCol,
  BLink,
  BCard,
  BButton,
  BAvatar,
  BBreadcrumb,
  BBreadcrumbItem,
} from "bootstrap-vue";

import { getUserData } from "@/auth/utils";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import shopStoreModule from "./shopStoreModule";
// import UserAddressList from '../users-address/UserAddressList.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BButton,
    BAvatar,
    BBreadcrumb,
    BBreadcrumbItem,

    AppTimeline,
    AppTimelineItem,

    // Local Components
    // UserAddressList,
  },
  setup() {
    const userData = getUserData();

    // Register module
    if (!store.hasModule("shop")) store.registerModule("shop", shopStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule("shop")) store.unregisterModule("shop");
    });

    const shopModel = ref(null);
    // const shopModel = {
    //   id: '',
    //   // eslint-disable-next-line global-require
    //   avatar: require('@/assets/images/slider/07.jpg'),
    //   name: 'ร้านตลาดนัดขนส่ง จำกัด',
    //   userName: '',
    //   password: 'xxxxx',
    //   firstName: '',
    //   lastName: '',
    //   idCardNumber: '',
    //   employeeId: '',
    //   phone: '',
    //   email: '',
    //   addressDetail: '',
    //   status: '',
    // }

    store
      .dispatch("shop/getShop", { id: userData.contactId })
      .then((response) => {
        console.log("response", response);

        shopModel.value = {
          shopName: userData.shopName,
          contactId: response.data.contactId,
          // eslint-disable-next-line global-require
          avatar: require("@/assets/images/slider/07.jpg"),
          userName: userData.username,
          password: "123456",
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          phone: response.data.phone,
          email: response.data.email,
          birthDate: response.data.birthDate,
          sex: "",
          address: "",
        };
      })
      .catch((error) => {});

    // const isAddNewUserSidebarActive = ref(false)

    return {
      shopModel,

      // // Sidebar
      // isAddNewUserSidebarActive,
    };
  },
  methods: {},
};
</script>

<style></style>
